import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-nav-button",
    styleUrls: ["./nav-button.component.scss"],
    templateUrl: "./nav-button.component.html"
})
export class FUINavButtonComponent extends FUIButtonComponent{

}
